import { render, staticRenderFns } from "./ContestViewTemplate.vue?vue&type=template&id=44b3c556&scoped=true&"
import script from "./ContestViewTemplate.vue?vue&type=script&lang=js&"
export * from "./ContestViewTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44b3c556",
  null
  
)

export default component.exports